import uniq from "lodash/fp/uniq";

export default function batchPreload(images: any[]) {
  if (typeof document !== "undefined" && document.images) {
    uniq(images.filter(Boolean)).forEach((imageSrc) => {
      if (imageSrc) {
        const image = new Image();
        image.src = imageSrc;
      }
    });
  }

  return [];
}
